const cartConfig = window?.["cartConfig"];
export const contextPath = window?.["contextPath"] ?? "";
export const baseCartApiUrl = cartConfig?.baseCartApiURL ?? "";
export const userId = cartConfig?.userId ?? "";
export const baseSiteId = cartConfig?.baseSiteId ?? "";
export const checkoutUrl = cartConfig?.checkoutUrl ?? "";
